import React, { MouseEventHandler } from "react";

export type CloseIconProps = {
  cx?: string;
  onClick?: MouseEventHandler<SVGSVGElement>;
};

export const CloseIcon: React.FC<CloseIconProps> = ({ cx = "", onClick }) => {
  return (
    <svg
      className={`CloseIcon ${cx}`}
      onClick={onClick}
      width="28"
      height="28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m9.688 9.691 8.615 8.616M9.688 18.309l8.615-8.616"
        stroke="#656565"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
